module.exports = __webpack_public_path__ + "static/media/international-competition-1.2.dc697d75.jpg";